import { type Component } from 'solid-js';

// The mark that carries a series' identity in a legend or a table header.
//
// A line rather than a dot, because identity here is a hue *and* a line pattern
// — past the eighth fund the palette starts again dashed — and a dot has nowhere
// to show a dash. Drawn at the same 2px weight as the chart's own lines so the
// legend and the plot read as the same object.
export const Swatch: Component<{ color: string; dash?: string }> = (props) => (
    <svg width='14' height='6' viewBox='0 0 14 6' class='shrink-0' aria-hidden='true'>
        <line x1='0' y1='3' x2='14' y2='3' stroke={props.color} stroke-width='2' stroke-dasharray={props.dash} stroke-linecap='round' />
    </svg>
);

export default Swatch;
